export default __webpack_public_path__ + "static/media/logo.9308f6c7.png";